export default __webpack_public_path__ + "static/media/MP5_6.5f5fd347.png";